import { useQuery } from "@tanstack/react-query";
import { AccountStatusVariant } from "../constants";
import { useRentReportingController } from "./rent-reporting-controller";
import { useAuthContext } from "providers/Auth";

const query = "portal/v1/customers/all";

export const useCountMetaRentReportingController = () => {
  const { type } = useAuthContext();
  const { getSubscribers, debouncedParams } = useRentReportingController();

  const pendingCountMeta = useQuery({
    queryKey: [
      query + "__total",
      {
        page: 1,
        per_page: 1,
        type: AccountStatusVariant.Pending,
        search: debouncedParams
      }
    ],
    queryFn: () =>
      getSubscribers(AccountStatusVariant.Pending).then((d) => {
        return d.total_count;
      }),
    enabled: type.isRentReporting || type.isSDK
  });

  const needToReportCountMeta = useQuery({
    queryKey: [
      query + "__total",
      {
        page: 1,
        per_page: 1,
        type: AccountStatusVariant.NeedToReport,
        search: debouncedParams
      }
    ],
    queryFn: () =>
      getSubscribers(AccountStatusVariant.NeedToReport).then((d) => {
        return d.total_count;
      }),
    enabled: type.isRentReporting || type.isSDK
  });

  return {
    pendingCountMeta,
    needToReportCountMeta
  };
};
